import { render } from "./titleManagement.vue?vue&type=template&id=631e61b3"
import script from "./titleManagement.vue?vue&type=script&lang=js"
export * from "./titleManagement.vue?vue&type=script&lang=js"

import "./titleManagement.vue?vue&type=style&index=0&id=631e61b3&lang=less"
script.render = render

export default script